import { jsxs as r, jsx as t, Fragment as v } from "react/jsx-runtime";
import { Box as i, Stack as I } from "@mui/material";
import { faArrowRightLong as T } from "@fortawesome/pro-regular-svg-icons";
import { T as D, c as h, I as X } from "./Slider-vVmtecg6.js";
import "@mui/material/Button";
import "react";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { s as m } from "./spacings-C27fg6SF.js";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import y from "@mui/material/Box";
import { T as c } from "./Typography-HkIo7ajX.js";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import { F as z, H as E, S as G, P as b, N as Q } from "./Negative-BXANdSjl.js";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
import { L as Y } from "./Logo-agH5zvpp.js";
import "@fortawesome/react-fontawesome";
import { P as S } from "./PolicyAndTermsLinks-C0ktDBVB.js";
import { G as j, M as N } from "./MicrosoftIcon-BAfd0N_m.js";
import "@mui/material/Typography";
const W = [
  { value: "😂", icon: /* @__PURE__ */ t(z, {}) },
  { value: "😍", icon: /* @__PURE__ */ t(E, {}) },
  { value: "😮", icon: /* @__PURE__ */ t(G, {}) },
  { value: "👍", icon: /* @__PURE__ */ t(b, {}) },
  { value: "👎", icon: /* @__PURE__ */ t(Q, {}) }
], Bi = ({
  authorName: o,
  isMobileView: a,
  feedback: n,
  setFeedback: e,
  onPost: p,
  shouldHideCreatorIdentity: l = !1
}) => {
  const s = l ? "creator" : o, g = l ? "the creator" : o;
  return /* @__PURE__ */ r(
    i,
    {
      px: m[a ? "lg" : "3xl"],
      py: m[a ? "lg" : "4xl"],
      width: "100%",
      children: [
        /* @__PURE__ */ t(
          i,
          {
            display: "flex",
            alignItems: "center",
            sx: {
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis"
            },
            children: /* @__PURE__ */ r(
              c,
              {
                variant: "text",
                size: "lg",
                fontWeight: "semibold",
                children: [
                  "Respond to ",
                  s
                ]
              }
            )
          }
        ),
        !a && /* @__PURE__ */ t(i, { mt: m.xs, children: /* @__PURE__ */ r(
          c,
          {
            variant: "text",
            size: "sm",
            color: "grey.600",
            children: [
              "We will let ",
              g,
              " know you left a feedback on the video"
            ]
          }
        ) }),
        /* @__PURE__ */ t(i, { mt: m["3xl"] }),
        /* @__PURE__ */ t(
          D,
          {
            value: n,
            onChange: (d) => {
              e(String(d.target.value));
            }
          }
        ),
        /* @__PURE__ */ r(
          i,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 1.8,
            children: [
              /* @__PURE__ */ t(
                I,
                {
                  spacing: m[a ? "xs" : "lg"],
                  direction: "row",
                  alignItems: "center",
                  mr: m.lg,
                  children: W.map((d, u) => /* @__PURE__ */ t(
                    i,
                    {
                      style: { cursor: "pointer" },
                      onClick: () => {
                        e(n + d.value);
                      },
                      children: d.icon
                    },
                    u
                  ))
                }
              ),
              /* @__PURE__ */ t(i, { width: 130, children: /* @__PURE__ */ t(
                h,
                {
                  color: "primary",
                  fullWidth: !0,
                  disabled: !n.length,
                  onClick: p,
                  variant: "contained",
                  size: "small",
                  endIcon: /* @__PURE__ */ t(X, { icon: T }),
                  children: "Share"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, x = ({ onClick: o, startIcon: a, label: n, isDisabled: e = !1 }) => /* @__PURE__ */ t(
  h,
  {
    fullWidth: !0,
    variant: "outlined",
    color: "secondary",
    size: "large",
    disabled: e,
    onClick: o,
    startIcon: a,
    children: n
  }
), L = ({
  googleLabel: o = "",
  microsoftLabel: a = "",
  disableButtons: n = !1,
  flexDirection: e = "column",
  spacing: p = m["3xl"],
  onGoogleClick: l = void 0,
  onMicrosoftClick: s = void 0
}) => /* @__PURE__ */ r(
  i,
  {
    display: "flex",
    flexDirection: e,
    width: "100%",
    children: [
      !!l && /* @__PURE__ */ t(
        x,
        {
          startIcon: j,
          onClick: l,
          label: o,
          isDisabled: n
        }
      ),
      e === "column" ? /* @__PURE__ */ t(i, { mt: p }) : /* @__PURE__ */ t(i, { mr: p }),
      !!s && /* @__PURE__ */ t(
        x,
        {
          startIcon: N,
          onClick: s,
          label: a,
          isDisabled: n
        }
      )
    ]
  }
), B = {
  width: 40,
  height: 40,
  overflow: "hidden",
  borderRadius: "50%"
}, Ci = ({
  isBackgroundLight: o = !1,
  isLoading: a,
  authorName: n,
  authorPhotoURL: e = "",
  shouldHideCreatorIdentity: p = !1,
  isMobileView: l,
  background: s = "",
  googleLabel: g,
  microsoftLabel: d,
  shouldHidePolicyAndTermsLink: u = !1,
  onGoogleClick: A,
  onMicrosoftClick: f,
  onPostAnonymously: C,
  onSingUpClick: w = void 0,
  termsLink: O = "",
  privacyPolicyLink: R = ""
}) => {
  const k = p ? "the creator" : n;
  return /* @__PURE__ */ r(
    i,
    {
      p: m["3xl"],
      pb: m.xl,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      children: [
        !!l && /* @__PURE__ */ r(i, { width: "100%", children: [
          /* @__PURE__ */ t(
            c,
            {
              variant: "text",
              size: "sm",
              fontWeight: "semibold",
              color: "text.primary",
              children: "Sign up"
            }
          ),
          /* @__PURE__ */ r(
            c,
            {
              variant: "text",
              size: "xs",
              children: [
                "to let ",
                n,
                " know you watched their guidde"
              ]
            }
          )
        ] }),
        !l && /* @__PURE__ */ r(v, { children: [
          /* @__PURE__ */ r(
            i,
            {
              style: { background: e ? "" : s },
              ...B,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              children: [
                !!e && !p && /* @__PURE__ */ t(
                  "img",
                  {
                    src: e,
                    alt: "author-photo-url",
                    style: { objectFit: "cover", ...B }
                  }
                ),
                !e && !p && /* @__PURE__ */ t(
                  c,
                  {
                    variant: "heading",
                    size: "xl",
                    color: o ? "inherit" : "white",
                    children: String(n).substring(0, 1)
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t(
            c,
            {
              variant: "heading",
              size: "xs",
              children: "Add your name to this comment"
            }
          ),
          /* @__PURE__ */ r(
            c,
            {
              variant: "text",
              size: "sm",
              children: [
                "Sign up and let ",
                k,
                " know you watched their Guidde"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ r(
          i,
          {
            width: "100%",
            mt: m[l ? "md" : "lg"],
            display: "flex",
            justifyContent: "center",
            pb: m.md,
            children: [
              !!w && /* @__PURE__ */ t(
                h,
                {
                  startIcon: /* @__PURE__ */ t(
                    Y,
                    {
                      variant: "light",
                      type: "singleLetter"
                    }
                  ),
                  color: "primary",
                  onClick: () => {
                    w();
                  },
                  size: "large",
                  variant: "contained",
                  children: "Sign up to Guidde"
                }
              ),
              (!!A || !!f) && /* @__PURE__ */ t(
                L,
                {
                  spacing: 1,
                  disableButtons: a,
                  flexDirection: l ? "row" : "column",
                  onGoogleClick: A,
                  onMicrosoftClick: f,
                  googleLabel: g,
                  microsoftLabel: d
                }
              )
            ]
          }
        ),
        !u && /* @__PURE__ */ t(
          S,
          {
            termsLink: O,
            privacyPolicyLink: R
          }
        ),
        /* @__PURE__ */ t(i, { mt: m[l ? "xxs" : "md"] }),
        /* @__PURE__ */ t(
          h,
          {
            variant: "text",
            onClick: C,
            disabled: a,
            size: "small",
            children: "Post comment anonymously"
          }
        )
      ]
    }
  );
}, F = "data:image/png;base64,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", Oi = ({ isMobileView: o }) => /* @__PURE__ */ r(
  y,
  {
    p: o ? 3 : 6,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    children: [
      /* @__PURE__ */ t(
        "img",
        {
          src: F,
          alt: "thank-you-image",
          width: o ? 60 : 120,
          height: o ? 50 : 100
        }
      ),
      /* @__PURE__ */ r(
        y,
        {
          mt: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          children: [
            /* @__PURE__ */ t(
              c,
              {
                variant: "text",
                fontWeight: "semibold",
                children: "Thank you"
              }
            ),
            /* @__PURE__ */ t(c, { variant: "text", children: "Your comment was sent!" })
          ]
        }
      )
    ]
  }
);
export {
  Bi as F,
  Ci as L,
  Oi as T
};
